import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth/services/auth.service';

import { LmRecordsService } from '@core/services/lm-records.service';
import { NavController } from '@ionic/angular';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { IMedicalLeave } from '@shared/interfaces/medical-leave.interface';
import { of } from 'rxjs';
import { catchError, debounceTime, map, pluck, switchMap, tap, withLatestFrom, mergeMap } from 'rxjs/operators';

import * as medicalLicencesActions from '../actions/medical-licences.actions';
import { AppState } from '../app.reducers';

@Injectable()
export class LmRecordsEffetcs {
  sk: string = '';
  constructor(
    private actions$: Actions,
    private lmRecordsService: LmRecordsService,
    private store: Store<AppState>,
    private router: Router,
  ) {}

  getParamToQuery(url: string, user: any) {
    if (user === null) {
      this.router.navigate([url]);
    }

    let param = null;
    switch (url) {
      case '/expedientes/panel/pendiente_contraloria':
        param = `ASIG#LM#DOC#pendiente_contraloria#${user.SK}`;
        break;
      case '/expedientes/panel/pendiente_subsidio':
        param = `ASIG#LM#DOC#pendiente_contraloria#${user.SK}`;
        break;
      case '/expedientes/panel/rechazo':
        param = `ASIG#LM#DOC#rechazo#${user.SK}`;
        break;
      case '/expedientes/panel/reduccion':
        param = `ASIG#LM#DOC#rechazo#${user.SK}`;
        break;
      case '/expedientes/panel/sin_derecho':
        param = `ASIG#LM#DOC#sin_derecho#${user.SK}`;
        break;
      case '/expedientes/panel/error_pago':
        param = `ASIG#LM#DOC#error_pago#${user.SK}`;
        break;
      default:
        param = '';
    }

    return param;
  }

  // ASIG#LM#DOC#pend_contraloria#USR#b8eca480-148e-11eb-975b-894187bb4459

  // tslint:disable-next-line: member-ordering
  findLmByAsignModule$ = createEffect(() =>
    this.actions$.pipe(
      ofType(medicalLicencesActions.LOAD_MEDICAL_LICENCE_ASSIGN),
      mergeMap(({ params }) =>
        this.lmRecordsService
          .getLicencesUnassigned(
            `${params.tipo_caso.includes('pendiente') ? 'LM' : 'RR'}#${params.tipo_caso}#${params.subcomision}#${
              params.tipo_lm
            }#${params.entidad_pagadora}`,
          )
          .pipe(
            map((lmRecords) => medicalLicencesActions.LOAD_LM_ASSIGN_SUCCESS({ lmRecords })),
            catchError((err) => of(medicalLicencesActions.LOAD_LM_ASSIGN_SUCCESS_FAIL({ payload: err }))),
          ),
      ),
    ),
  );

  // tslint:disable-next-line: member-ordering
  allMedicalLicenseByContraloriaMedica$ = createEffect(() =>
    this.actions$.pipe(
      ofType(medicalLicencesActions.LOAD_ALL_MEDICAL_LICENCE),
      debounceTime(1),
      withLatestFrom(this.store.select((state) => state.auth.user).pipe(pluck('accesos'))),
      switchMap(([action, accesos]) => {
        const permiso = accesos.find((element) => element.path.includes('todos_pendiente'));
        const subcomisiones = [...permiso.subcomisiones];
        let stringSubcomisiones = '';
        subcomisiones.map((sub, index) => {
          if (index === 0) {
            stringSubcomisiones = sub.codigo_subcomision.toString();
          } else {
            stringSubcomisiones += ',' + sub.codigo_subcomision.toString();
          }
        });
        return this.lmRecordsService
          .getAllLicensesBySubcomission(`LM#pendiente_contraloria#${stringSubcomisiones}#todos#todos`)
          .pipe(
            map((lmRecords) => medicalLicencesActions.LOAD_ALL_LM_PENDING_MEDICAL_CONTROLLER_SUCCESS({ lmRecords })),
            catchError((err) => of(medicalLicencesActions.LOAD_MEDICAL_LICENCE_FAIL({ payload: err }))),
          );
      }),
    ),
  );
  // tslint:disable-next-line: member-ordering
  allMedicalLicenseBySubsidio$ = createEffect(() =>
    this.actions$.pipe(
      ofType(medicalLicencesActions.LOAD_ALL_MEDICAL_LICENCE),
      debounceTime(1),
      withLatestFrom(this.store.select((state) => state.auth.user).pipe(pluck('accesos'))),
      switchMap(([action, accesos]) => {
        const permiso = accesos.find((element) => element.path.includes('todos_pendiente'));
        const subcomisiones = [...permiso.subcomisiones];
        let stringSubcomisiones = '';
        subcomisiones.map((sub, index) => {
          if (index === 0) {
            stringSubcomisiones = sub.codigo_subcomision.toString();
          } else {
            stringSubcomisiones += ',' + sub.codigo_subcomision.toString();
          }
        });
        return this.lmRecordsService
          .getAllLicensesBySubcomission(`LM#pendiente_subsidio#${stringSubcomisiones}#todos#todos`)
          .pipe(
            map((lmRecords) => medicalLicencesActions.LOAD_ALL_LM_PENDING_SUBSIDY_SUCCESS({ lmRecords })),
            catchError((err) => of(medicalLicencesActions.LOAD_MEDICAL_LICENCE_FAIL({ payload: err }))),
          );
      }),
    ),
  );
  // tslint:disable-next-line: member-ordering
  allMedicalLicenseByRechazo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(medicalLicencesActions.LOAD_ALL_MEDICAL_LICENCE),
      debounceTime(1),
      withLatestFrom(this.store.select((state) => state.auth.user).pipe(pluck('accesos'))),
      switchMap(([action, accesos]) => {
        const permiso = accesos.find((element) => element.path.includes('todos_pendiente'));
        const subcomisiones = [...permiso.subcomisiones];
        let stringSubcomisiones = '';
        subcomisiones.map((sub, index) => {
          if (index === 0) {
            stringSubcomisiones = sub.codigo_subcomision.toString();
          } else {
            stringSubcomisiones += ',' + sub.codigo_subcomision.toString();
          }
        });
        return this.lmRecordsService.getAllLicensesBySubcomission(`RR#rechazo#${stringSubcomisiones}#todos#todos`).pipe(
          map((lmRecords) => medicalLicencesActions.LOAD_ALL_RR_REJECTION_SUCCESS({ lmRecords })),
          catchError((err) => of(medicalLicencesActions.LOAD_MEDICAL_LICENCE_FAIL({ payload: err }))),
        );
      }),
    ),
  );
  // tslint:disable-next-line: member-ordering
  allMedicalLicenseByReduccion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(medicalLicencesActions.LOAD_ALL_MEDICAL_LICENCE),
      debounceTime(1),
      withLatestFrom(this.store.select((state) => state.auth.user).pipe(pluck('accesos'))),
      switchMap(([action, accesos]) => {
        const permiso = accesos.find((element) => element.path.includes('todos_pendiente'));
        const subcomisiones = [...permiso.subcomisiones];
        let stringSubcomisiones = '';
        subcomisiones.map((sub, index) => {
          if (index === 0) {
            stringSubcomisiones = sub.codigo_subcomision.toString();
          } else {
            stringSubcomisiones += ',' + sub.codigo_subcomision.toString();
          }
        });
        return this.lmRecordsService
          .getAllLicensesBySubcomission(`RR#reduccion#${stringSubcomisiones}#todos#todos`)
          .pipe(
            map((lmRecords) => medicalLicencesActions.LOAD_ALL_RR_REDUCTION_SUCCESS({ lmRecords })),
            catchError((err) => of(medicalLicencesActions.LOAD_MEDICAL_LICENCE_FAIL({ payload: err }))),
          );
      }),
    ),
  );

  // tslint:disable-next-line: member-ordering
  allMedicalLicenseBySinDerecho$ = createEffect(() =>
    this.actions$.pipe(
      ofType(medicalLicencesActions.LOAD_ALL_MEDICAL_LICENCE),
      debounceTime(1),
      withLatestFrom(this.store.select((state) => state.auth.user).pipe(pluck('accesos'))),
      switchMap(([action, accesos]) => {
        const permiso = accesos.find((element) => element.path.includes('todos_pendiente'));
        const subcomisiones = [...permiso.subcomisiones];
        let stringSubcomisiones = '';
        subcomisiones.map((sub, index) => {
          if (index === 0) {
            stringSubcomisiones = sub.codigo_subcomision.toString();
          } else {
            stringSubcomisiones += ',' + sub.codigo_subcomision.toString();
          }
        });
        return this.lmRecordsService
          .getAllLicensesBySubcomission(`RR#sin_derecho#${stringSubcomisiones}#todos#todos`)
          .pipe(
            map((lmRecords) => medicalLicencesActions.LOAD_ALL_RR_NO_RIGHT_SUCCESS({ lmRecords })),
            catchError((err) => of(medicalLicencesActions.LOAD_MEDICAL_LICENCE_FAIL({ payload: err }))),
          );
      }),
    ),
  );
  // tslint:disable-next-line: member-ordering
  allMedicalLicenseByErrorPago$ = createEffect(() =>
    this.actions$.pipe(
      ofType(medicalLicencesActions.LOAD_ALL_MEDICAL_LICENCE),
      debounceTime(1),
      withLatestFrom(this.store.select((state) => state.auth.user).pipe(pluck('accesos'))),
      switchMap(([action, accesos]) => {
        const permiso = accesos.find((element) => element.path.includes('todos_pendiente'));
        const subcomisiones = [...permiso.subcomisiones];
        let stringSubcomisiones = '';
        subcomisiones.map((sub, index) => {
          if (index === 0) {
            stringSubcomisiones = sub.codigo_subcomision.toString();
          } else {
            stringSubcomisiones += ',' + sub.codigo_subcomision.toString();
          }
        });
        return this.lmRecordsService
          .getAllLicensesBySubcomission(`RR#error_pago#${stringSubcomisiones}#todos#todos`)
          .pipe(
            map((lmRecords) => medicalLicencesActions.LOAD_ALL_RR_PAYMENT_ERROR_SUCCESS({ lmRecords })),
            catchError((err) => of(medicalLicencesActions.LOAD_MEDICAL_LICENCE_FAIL({ payload: err }))),
          );
      }),
    ),
  );

  // Licencias medicas pendientes por contraloria medica
  lmPendingByMedicalController$ = createEffect(() =>
    this.actions$.pipe(
      ofType(medicalLicencesActions.LOAD_MEDICAL_LICENCE),
      debounceTime(1),
      withLatestFrom(this.store.select((state) => state.auth.user).pipe(pluck('SK'))),
      switchMap(([action, usersk]) =>
        this.lmRecordsService.getLicencesByStateAndUser(`ASIG#LM#pendiente_contraloria#${usersk}`).pipe(
          map((lmRecords) => medicalLicencesActions.LOAD_LM_PENDING_MEDICAL_CONTROLLER_SUCCESS({ lmRecords })),
          catchError((err) => of(medicalLicencesActions.LOAD_MEDICAL_LICENCE_FAIL({ payload: err }))),
        ),
      ),
    ),
  );

  // Licencias medicas pendiente de subsidio
  lmPendingBySubsidy$ = createEffect(() =>
    this.actions$.pipe(
      ofType(medicalLicencesActions.LOAD_MEDICAL_LICENCE),
      debounceTime(1),
      withLatestFrom(this.store.select((state) => state.auth.user).pipe(pluck('SK'))),
      switchMap(([action, usersk]) =>
        this.lmRecordsService.getLicencesByStateAndUser(`ASIG#LM#pendiente_subsidio#${usersk}`).pipe(
          map((lmRecords) => medicalLicencesActions.LOAD_LM_PENDING_SUBSIDY_SUCCESS({ lmRecords })),
          catchError((err) => of(medicalLicencesActions.LOAD_MEDICAL_LICENCE_FAIL({ payload: err }))),
        ),
      ),
    ),
  );

  // recursos de reposicion por rechazo
  rrByRejection$ = createEffect(() =>
    this.actions$.pipe(
      ofType(medicalLicencesActions.LOAD_MEDICAL_LICENCE),
      debounceTime(1),
      withLatestFrom(this.store.select((state) => state.auth.user).pipe(pluck('SK'))),
      switchMap(([action, usersk]) =>
        this.lmRecordsService.getLicencesByStateAndUser(`ASIG#RR#rechazo#${usersk}`).pipe(
          map((lmRecords) => medicalLicencesActions.LOAD_RR_REJECTION_SUCCESS({ lmRecords })),
          catchError((err) => of(medicalLicencesActions.LOAD_MEDICAL_LICENCE_FAIL({ payload: err }))),
        ),
      ),
    ),
  );

  // recursos de reposicion por reduccion
  rrByReduction$ = createEffect(() =>
    this.actions$.pipe(
      ofType(medicalLicencesActions.LOAD_MEDICAL_LICENCE),
      debounceTime(1),
      withLatestFrom(this.store.select((state) => state.auth.user).pipe(pluck('SK'))),
      switchMap(([action, usersk]) =>
        this.lmRecordsService.getLicencesByStateAndUser(`ASIG#RR#reduccion#${usersk}`).pipe(
          map((lmRecords) => medicalLicencesActions.LOAD_RR_REDUCTION_SUCCESS({ lmRecords })),
          catchError((err) => of(medicalLicencesActions.LOAD_MEDICAL_LICENCE_FAIL({ payload: err }))),
        ),
      ),
    ),
  );

  // recursos de reposicion sin derecho a pago
  rrNoRightPayment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(medicalLicencesActions.LOAD_MEDICAL_LICENCE),
      debounceTime(1),
      withLatestFrom(this.store.select((state) => state.auth.user).pipe(pluck('SK'))),
      switchMap(([action, usersk]) =>
        this.lmRecordsService.getLicencesByStateAndUser(`ASIG#RR#sin_derecho#${usersk}`).pipe(
          map((lmRecords) => medicalLicencesActions.LOAD_RR_NO_RIGHT_SUCCESS({ lmRecords })),
          catchError((err) => of(medicalLicencesActions.LOAD_MEDICAL_LICENCE_FAIL({ payload: err }))),
        ),
      ),
    ),
  );

  // recursos de reposicion por error de pago
  rrPaymentError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(medicalLicencesActions.LOAD_MEDICAL_LICENCE),
      debounceTime(1),
      withLatestFrom(this.store.select((state) => state.auth.user).pipe(pluck('SK'))),
      switchMap(([action, usersk]) =>
        this.lmRecordsService.getLicencesByStateAndUser(`ASIG#RR#error_pago#${usersk}`).pipe(
          map((lmRecords) => medicalLicencesActions.LOAD_RR_PAYMENT_ERROR_SUCCESS({ lmRecords })),
          catchError((err) => of(medicalLicencesActions.LOAD_MEDICAL_LICENCE_FAIL({ payload: err }))),
        ),
      ),
    ),
  );
}
